import { IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as LockIcon } from 'assets/icons/lock.svg';
import { ReactComponent as LockedIcon } from 'assets/icons/locked.svg';
import { useAppDispatch, useAppSelector } from 'modules/Editor/store';
import { selectIsWidgetLocked } from 'modules/Editor/store/infographSelector';
import { updateWidget } from 'modules/Editor/store/infographSlice';
import { selectActiveWidgets } from 'modules/Editor/store/widgetSelector';
import { useTranslation } from 'react-i18next';
import { WidgetType } from 'types/widget.types';
import { getWidgetTypeFromId } from 'widgets/Widget.helpers';

import { BUTTON_SIZE, ICON_SIZE } from '../WidgetControl.config';

export const LockControl = () => {
  const { t } = useTranslation('editor_toolbar');

  const activeWidgets = useAppSelector(selectActiveWidgets);
  const isLocked = useAppSelector(selectIsWidgetLocked);
  const dispatch = useAppDispatch();
  const activeWidgetType = getWidgetTypeFromId(activeWidgets[0]?.id || '');
  const isLine = activeWidgetType === WidgetType.Line;

  // Groups + responsive widgets can't be locked, hide for lines
  const showLock = !!activeWidgets[0] && !activeWidgets[0].groupId && !activeWidgets[0].responsiveGroupId && !isLine;

  const lockText = t('lockBtn.label');
  const unlockText = t('unlockBtn.label');
  const label = isLocked ? unlockText : lockText;

  const onClick = () => {
    if (!activeWidgets[0]) {
      return;
    }

    const widgetId = activeWidgets[0].id;
    dispatch(updateWidget({ widgetId, widgetData: { isLocked: !isLocked } }));
  };

  if (!showLock) {
    return null;
  }

  return (
    <Tooltip hasArrow placement='top' label={label} bg='black'>
      <IconButton
        aria-label={label}
        color='font.500'
        width={`${BUTTON_SIZE}px`}
        height={`${BUTTON_SIZE}px`}
        icon={
          isLocked ? (
            <LockedIcon width={ICON_SIZE} height={ICON_SIZE} />
          ) : (
            <LockIcon width={ICON_SIZE} height={ICON_SIZE} />
          )
        }
        variant='icon-btn-widget-ctrl'
        onClick={onClick}
      />
    </Tooltip>
  );
};
